module.exports = __webpack_public_path__ + "static/media/drag-city-home.d3f46071.jpg";